import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { reduxForm } from 'redux-form';
import '../../css/remove-from-group.css';

class WithdrawFromPurchaseDefault extends Component {
  membershipNames() {
    const { memberships } = this.props;
    return memberships.map(member => this.singleMembershipName(member)).join(', ');
  }

  singleMembershipName(membership) {
    if (!membership.user.fullName) return membership.user.email;
    return membership.user.fullName;
  }

  render() {
    const { handleSubmit, isSubmitting } = this.props;

    return (
      <div>
        <div className="modal-section modal-title text-center blue full">
          <h1>
            <FormattedMessage
              id="removeFor.default.title"
              defaultMessage="Remove from group"
            />
          </h1>
        </div>
        <form className="remove-from-group" onSubmit={handleSubmit(this.props.onSubmit)}>
          <div className="mx-4">
            <p>
              <FormattedMessage
                id="removeFor.default.contributors"
                defaultMessage="Contributors being removed"
              />
            </p>
            <div className="cool-grey mb-3">
              {this.membershipNames()}
            </div>
            <p>
              <FormattedMessage
                id="removeFor.default.warning"
                defaultMessage="If you remove this invitee, they will no longer
                  count towards your group's total, and they will not
                  receive any future updates about this purchase."
              />
            </p>
            <hr className="mt-5" />
            <div className="row">
              <div className="col-7">
                <button
                  type="button"
                  className="btn btn-link cool-gray float-right"
                  onClick={this.props.onCancel}
                >
                  <FormattedMessage
                    id="removeFor.default.cancelButton"
                    defaultMessage="Cancel"
                  />
                </button>
              </div>
              <div className="col-5">
                <button
                  className="btn btn-primary btn-remove"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {!isSubmitting && (
                    <FormattedMessage
                      id="removeFor.default.confirmButton"
                      defaultMessage="Confirm removal"
                    />
                  )}
                  {isSubmitting && (
                    <FormattedMessage
                      id="removeFor.default.removing"
                      defaultMessage="Removing"
                    />
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({ form: 'withdrawFromPurchase' })(WithdrawFromPurchaseDefault);



// WEBPACK FOOTER //
// ./src/desktop/components/remove-from-purchase/remove-for.default.js